/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import DatePicker from '@roo/roo/DatePicker';
import Select, { SelectOptions } from '@roo/roo/Select';
import Form from '@roo/roo/Form';
import Button from '@roo/roo/Button';
import Grid from '@roo/roo/Grid';
import dayjs from 'dayjs';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';

import {
    IAnyliseFormProps,
    TABLE_TYPE,
    SubmitReq,
    getAnalysisDownloadSubmit,
    customerTypeMap,
    IMap,
    getAllCoopmode,
    ICooperateList,
} from '../api';

dayjs.extend(CustomParseFormat);

const { RangePicker } = DatePicker;
const { Field } = Form;
const { Row, Col } = Grid;

const defaultFormValue: SubmitReq = {
    type: TABLE_TYPE.DAILY,
    customerSource: '',
    startDate: '',
    endDate: '',
    queryDate: '',
    coopMode: 0,
};

function AnalyseForm(props: IAnyliseFormProps) {
    const { type, title, buttonTitle, updateTableData, startDate, dateRange = false } = props;

    const [formValue, setFormValue] = useState<SubmitReq>({
        ...defaultFormValue,
        type,
    });
    const [load, setLoad] = useState<boolean>(false);
    const [coopModeList, setCoopModeList] = useState<ICooperateList>([{ value: 0, label: '全部' }]); // 合作模式筛选项
    const formRef = React.useRef<Form>(null);
    useEffect(() => {
        getAllCoopmode({ customSource: -1 }).then(res => {
            const { data } = res;
            changeCoopModeList(data);
        });
    }, []);

    const changeCoopModeList = (list: ICooperateList) => {
        if (list.length > 0) {
            list.unshift({
                value: 0,
                label: '全部',
            });
        }
        setCoopModeList(list);
    };

    const rules = {
        customerSource: {
            required: true,
            message: '客户来源必填',
        },
        coopMode: {
            required: true,
            message: '合作模式必填',
        },
        queryDate: [
            {
                validator(rule: any, value: any, callback: any) {
                    if (!value) callback('请填写日期');
                    else if (!dateRange) callback();
                    else {
                        const a = dayjs(value[0], 'YYYYMMDD');
                        const b = dayjs(value[1], 'YYYYMMDD');
                        const dif = b.diff(a, 'day');
                        if (dif > 30) callback('日期间隔不能超过30天');
                        else callback();
                    }
                },
            },
        ],
    };
    const cols = {
        label: { span: 4 },
        field: { span: 8 },
    };

    /**
     * 禁用日前范围
     * @param cur 当前选择的日期
     * @returns 日期不得早于 2022-01-01 或 早于 startDate 或大于 今天往后的日子
     */
    const disableDate = (cur: dayjs.Dayjs) =>
        +cur < +dayjs().subtract(24, 'month') ||
        +cur > Date.now() - 86400000 ||
        +cur < +dayjs(startDate, 'YYYY-MM-DD');

    /** 日期筛选 */
    const dateSelect = () => {
        if (dateRange) {
            return (
                <RangePicker format="YYYYMMDD" valueOfType="string" disabledDate={disableDate} />
            );
        }
        return <DatePicker format="YYYYMMDD" valueOfType="string" disabledDate={disableDate} />;
    };

    /** 客户来源 */
    const customerSelect = () => {
        const options: SelectOptions[] = [];
        Object.keys(customerTypeMap).forEach(k => {
            options.push({ value: k, label: (customerTypeMap as IMap)[k] });
        });
        return <Select options={options} />;
    };

    /** 合作模式 */
    const cooperateSelect = () => <Select options={coopModeList} style={{ width: '200px' }} />;

    return (
        <>
            <p>{title}</p>
            <Form
                value={{}}
                alwaysUpdate={false}
                rules={rules}
                ref={formRef}
                onSubmit={(value, error) => {
                    // console.log(formValue, value);
                    if (error) return;
                    setLoad(true);
                    getAnalysisDownloadSubmit(formValue)
                        .then(res => {
                            updateTableData();
                            setLoad(false);
                        })
                        .catch(() => {
                            setLoad(false);
                        });
                    // onSubmit(formValue);
                }}
                layout="horizontal"
                cols={cols}
                onChange={(name: string, value: any) => {
                    if (!value) return;
                    if (name === 'queryDate' && dateRange) {
                        setFormValue({ ...formValue, startDate: value[0], endDate: value[1] });
                    } else if (name === 'customerSource') {
                        getAllCoopmode({ customSource: value }).then(({ data }) => {
                            changeCoopModeList(data);
                            formRef.current?.setFieldValue('coopMode', 0); // 改变客户来源，合作模式默认全部
                            setFormValue({
                                ...formValue,
                                [name]: value,
                                coopMode: 0,
                            });
                        });
                    } else {
                        setFormValue({ ...formValue, [name]: value });
                    }
                }}
            >
                {({ submitForm }: any) => (
                    <form>
                        <Row>
                            <Col span={3}>
                                <Field label="日期选择" name="queryDate" as={dateSelect()} />
                            </Col>
                            <Field label="客户来源" name="customerSource" as={customerSelect()} />
                            <Field
                                label="合作模式"
                                name="coopMode"
                                as={cooperateSelect()}
                                disabled={formValue.customerSource === ''}
                            />
                            <Col span={1}>
                                <Field>
                                    <Button loading={load} type="hollow" onClick={submitForm}>
                                        {buttonTitle}
                                    </Button>
                                </Field>
                            </Col>
                        </Row>
                    </form>
                )}
            </Form>
        </>
    );
}
export default AnalyseForm;
